import { API } from "@/services"

export const CALLS_ENDPOINTS = {
  getActiveCalls(params={}){
    return API.Axios.callstats.v1.request({
      url: `calls/active-calls`,
      method: 'GET',
      params,
    })
  },
}